import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class QrCode extends Entity<QrCode> {
    @Expose()
    image!: string
}
